module.exports = __webpack_public_path__ + "img/m2mxLogo.75acb67b.png";